// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"969":"css/admin-app.6835","5013":"css/app.6835"}[chunkId] + ".css";
};